var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.customer.id && _vm.fetchedContacts)?_c('contact-modal',{attrs:{"contact":_vm.contact,"customer":_vm.customer},on:{"update":_vm.update}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }